import { useEffect, useMemo, useState } from 'react'

const useIsScrolled = (): boolean => {
  const [isScrolled, setIsScrolled] = useState<boolean>(false)

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll)
    return () => {
      window.removeEventListener('scroll', listenToScroll)
    }
  }, [])

  const listenToScroll = (): void => {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop

    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight

    const scrolled = winScroll / height

    setIsScrolled(scrolled > 0)
  }

  return useMemo(() => isScrolled, [isScrolled])
}

export default useIsScrolled
